import { useEffect, useRef, useState } from 'react';
import { subscribeMeterHistory, getLatestHistorySnapshot } from './meterSocket';
import { matchMeterField } from './meterFields';

const DEFAULT_METER_ID = 'TEST_1_1';

function applyHeatmap(snapshot, field) {
    if (!field || !snapshot || snapshot.error || !snapshot.heatmap) return null;
    const { heatmap } = snapshot;
    const grid = field.get(heatmap);
    if (!Array.isArray(grid)) return null;
    const days = Array.isArray(heatmap.days) ? heatmap.days : [];
    const hours = Array.isArray(heatmap.hours) ? heatmap.hours : [];
    const series = days.map((day, di) => ({
        name: day,
        data: hours.map((hour, hi) => ({ x: hour, y: Number(grid[di]?.[hi]) || 0 })),
    }));
    return { series };
}

export default function useMeterFieldHeatmap(title, { meterId = DEFAULT_METER_ID, skip = false } = {}) {
    const field = skip ? null : matchMeterField(title);
    const fieldRef = useRef(field);
    fieldRef.current = field;

    const [state, setState] = useState({ series: [] });

    useEffect(() => {
        if (!field || skip) {
            setState({ series: [] });
            return;
        }
        const cached = getLatestHistorySnapshot(meterId);
        const applied = cached && applyHeatmap(cached, field);
        setState(applied || { series: [] });
    }, [field?.label, skip, meterId]);

    useEffect(() => {
        if (skip) return undefined;

        const handleSnapshot = (snapshot) => {
            const applied = applyHeatmap(snapshot, fieldRef.current);
            if (applied) setState(applied);
        };

        return subscribeMeterHistory(meterId, handleSnapshot);
    }, [meterId, skip]);

    return { field, ...state };
}
